import React from 'react'
import FoodCard from '../components/FoodCard'
import Banner from '../components/Banner'
import Footer from '../components/Footer'

export default function Home() {

  return (
    <>
      <Banner />
      <FoodCard />
      <Footer />
    </>
  )
}
